<script lang="ts">
	import { removeUrlScheme } from '$lib';
	import { onMount } from 'svelte';

	const {
		trustpilot,
		base_url,
		locale,
	}: {
		trustpilot?: Trustpilot;
		base_url: Config['base_url'];
		locale: Config['locale'];
	} = $props();

	let widget: HTMLElement | undefined = $state();

	function loadTrustpilotScript(): Promise<void> {
		return new Promise((resolve, reject) => {
			if (window.Trustpilot) return resolve();

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
			script.async = true;
			script.onload = () => resolve();
			script.onerror = reject;
			document.head.appendChild(script);
		});
	}

	const hasTpConfig = $derived(!!trustpilot && !!base_url && !!locale);

	onMount(async () => {
		if (!hasTpConfig) return;

		await loadTrustpilotScript();

		if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function' && widget)
			window.Trustpilot.loadFromElement(widget, true);
	});
</script>

{#if hasTpConfig}
	<!-- TrustBox widget - Mini -->
	<div
		bind:this={widget}
		class="trustpilot-widget"
		data-locale={locale.slice(0, 2)}
		data-template-id={trustpilot?.template}
		data-businessunit-id={trustpilot?.id}
		data-style-height="150px"
		data-style-width="100%"
		data-theme="dark"
	>
		<a
			href={`https://${locale.slice(0, 2)}.trustpilot.com/review/${removeUrlScheme(base_url)}`}
			target="_blank"
			rel="noopener nofollow">Trustpilot</a
		>
	</div>
	<!-- End TrustBox widget -->
{/if}
